export const about = {
  label: 'Empresa',
  title: 'Propósito y Principios',
  purpose: {
    title: 'Propósito de la Holding',
    content: 'Mantener y gestionar participaciones en nombre propio y por cuenta propia, no como servicio para terceros, así como la gestión de patrimonio propio. DR Group GmbH es una sociedad de participaciones que no presta servicios operativos.'
  },
  principles: {
    title: 'Principios',
    content: 'Seguimos una estrategia a largo plazo en la selección y gestión de nuestras participaciones. Nuestras decisiones se basan en un análisis cuidadoso y estructuras de gobernanza claras.'
  },
  governance: {
    title: 'Gobernanza',
    content: 'Clara separación entre el nivel de holding y las participaciones operativas. La holding asume la propiedad, la asignación de capital y la gobernanza, mientras que las participaciones operan de forma independiente.'
  },
  separation: {
    title: 'Separación de Roles',
    holdco: {
      label: 'HoldCo',
      items: [
        'Propiedad',
        'Asignación de capital',
        'Gobernanza'
      ]
    },
    participations: {
      label: 'Participaciones',
      items: [
        'Actividad operativa',
        'Celebración de contratos',
        'Prestación de servicios'
      ]
    }
  }
};